import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ListboxClickEvent} from "primeng/listbox";
import {BasketDto} from "../../../../models/basket-dto";

@Component({
  selector: 'locus-basket-groups',
  templateUrl: './locus-basket-groups.component.html',
  styleUrls: ['./locus-basket-groups.component.scss']
})
export class LocusBasketGroupsComponent {

  @Input() basketGroups!: any;
  @Output() selected = new EventEmitter<any>();
  selectedGroup: any;


  constructor() {
  }

  itemSelected($event: ListboxClickEvent) {
    this.selected.emit({ 'baskets': $event.value.baskets, 'groupName': $event.value.basketType });
  }
}
